import React, { useState, useEffect } from 'react';

import ToggleButton from '../../../../../common/ToggleButton/ToggleButton';
import styles from './CreditBureauTab.module.scss';
import DirectorDetails, { IDirectorDetails } from '../DirectorDetails/DirectorDetails';
import { USER_TYPE } from '../../../../../utils/constants/user';
import { useAppSelector } from '../../../../../app/hooks';
import { ALL_TAB } from '../../../../../store/dashboard/creditBureau/constants';

export const DIRECT_CIBIL_DATA = 'directorCibilData';

const CreditBureauTab = ({
    directorCibilData,
    updateFunction,
    userType,
    assesseeOrgId,
    categoryId,
    flowId,
    managementData,
    isInvestor,
}) => {
    const [lenderConsent, setLenderConsent] = useState(directorCibilData?.lenderDirectorCibilConsent || false);
    const [borrowerConsent, setBorrowerConsent] = useState(directorCibilData?.borrowerDirectorCibilConsent || false);
    const [consent, setConsent] = useState<boolean>(false);
    const hasCibiReportsData = directorCibilData?.lenderDirectorCibilReports?.filter((report) => !report?.isDeleted);

    const investorData = useAppSelector((state) => state.investor);
    const companyData = useAppSelector((state) => state.company);

    const [directorDetails, setDirectorDetails] = useState<Record<string, IDirectorDetails[]>>({});

    const managementList = useAppSelector((state: any) => state.company?.uploadJourneyData?.cibilSoftPullData?.managementList);

    const getCreditBureauConfig = (userType: string) => {
        if (userType === USER_TYPE.INVESTOR) {
            return investorData?.config?.tabConfigs?.creditBureau?.tabsToDisplay;
        } else if (userType === USER_TYPE.COMPANY) {
            return companyData?.config?.tabConfigs?.creditBureau?.tabsToDisplay;
        }
        return {};
    };
    const creditBureauConfig = getCreditBureauConfig(userType);

    const creditBureaus =
        Object.values(creditBureauConfig)?.filter((config: any) => config?.isActive && config?.isDirectorInputToBeTaken) || [];

    const bureauNames = creditBureaus?.map((config: any) => config?.name) || [];

    const formatDataAndUpdateState = (managementList: any) => {
        const list = managementList.map((director: any) => {
            return {
                directorName: director.name,
                phoneNo: director.phoneNumber,
                consentStatus: director.cibilConsentStatus,
                lastInviteSentAt: director.lastInviteSentAt,
                updatedAt: director.updatedAt,
                cibilConsentStatus: director.cibilConsentStatus,
                isNewDir: false,
                pan: director?.primaryPan,
            };
        });
        const bureauNameDirectorMap = {};
        for (const bureauName of bureauNames) {
            bureauNameDirectorMap[bureauName] = list.map((item: any) => ({ ...item }));
        }
        setDirectorDetails(bureauNameDirectorMap);
    };

    useEffect(() => {
        if (managementList) {
            formatDataAndUpdateState(managementList);
        }
    }, [managementList]);

    useEffect(() => {
        setLenderConsent(directorCibilData?.lenderDirectorCibilConsent || false);
        setBorrowerConsent(directorCibilData?.borrowerDirectorCibilConsent || false);
    }, [directorCibilData]);

    useEffect(() => {
        setLenderConsent(directorCibilData?.lenderDirectorCibilConsent || false);
        setBorrowerConsent(directorCibilData?.borrowerDirectorCibilConsent || false);
    }, [directorCibilData]);

    const updateLenderCibilConsent = () => {
        const newConsentValue = !lenderConsent;
        setLenderConsent(newConsentValue);
        updateFunction(
            {
                lenderDirectorCibilConsent: newConsentValue,
            },
            DIRECT_CIBIL_DATA,
        );
    };

    const directorListSize = Object.values(creditBureauConfig).filter((config: any) => config.isActive && config.name != ALL_TAB).length; // directorListSize is the total config length minus the ALl_TAB if present

    const isConsentStatusTrue = (consentStatusObject: any, key: string | null = null) => {
        // Check if item.cibilConsentStatus is an object

        if (consentStatusObject && typeof consentStatusObject === 'object') {
            // Check if any value in the object is true
            if (key) return consentStatusObject[key] === true;
            return Object.values(consentStatusObject).some((value: any) => value?.isConsentGiven === true);
        }
        return false;
    };

    return (
        <>
            {userType === USER_TYPE.INVESTOR ? (
                <div className={styles.Top}>
                    We have consent to fetch bureau details for directors
                    <ToggleButton
                        checked={borrowerConsent ? borrowerConsent : lenderConsent}
                        onChange={updateLenderCibilConsent}
                        disabled={
                            (lenderConsent || borrowerConsent) &&
                            (directorCibilData?.lenderDirectorCibilReports?.length > 0 ||
                                consent ||
                                managementData?.some((item) => isConsentStatusTrue(item.cibilConsentStatus)) ||
                                directorCibilData?.borrowerDirectorVerified)
                        }
                    />
                </div>
            ) : (
                <div></div>
            )}

            {(lenderConsent || userType === USER_TYPE.COMPANY) && (
                <>
                    {creditBureaus.map((config: any, idx: number) => {
                        return (
                            <React.Fragment key={config.name || idx}>
                                <div style={isInvestor ? { width: '100%', border: 'none' } : {}} className={styles.Equafix}>
                                    <DirectorDetails
                                        isInvestorSide={userType == USER_TYPE.INVESTOR}
                                        setConsent={setConsent}
                                        creditBureauConfig={config}
                                        directorDetails={directorDetails[config.name] || []}
                                        setDirectorDetails={setDirectorDetails}
                                    />
                                </div>
                                {idx < directorListSize - 1 && (
                                    <div className={styles.Separator}>
                                        <div className={styles.Line}></div>
                                        <div>Or</div>
                                        <div className={styles.Line}></div>
                                    </div>
                                )}
                            </React.Fragment>
                        );
                    })}
                </>
            )}
        </>
    );
};

export default CreditBureauTab;
